/**
 * ERP Calculator
 * Boiler efficieny calculator
 * Handlebar templates can be found in: 'public_html/html/ERP-Calculator.php'
 * Values are stored in hidden input fields
 */

import $ from 'jquery';
import Handlebars from 'handlebars';

// Cached elements
const $el = {
	boilerDropdown: $('#js-erp-boiler-dropdown'),
	boilerContent: $('#js-erp-boiler-content'),
	controlsDropdown: $('#js-erp-controls-dropdown'),
	controlsContent: $('#js-erp-controls-content'),
	solarToggle: $('#js-erp-solar-toggle'),
	solarForm: $('#js-erp-solar-form'),
	emailToggle: $('#js-erp-email-toggle'),
	emailForm: $('#js-erp-email-form'),
	emailNameInput: $('#js-erp-email-name-input'),
	emailAddressInput: $('#js-erp-email-address-input'),
	emailSubmitBtn: $('#js-erp-email-submit-btn'),
	emailStatus: $('#js-erp-email-status'),
	solarFields: {
		all: $('#js-erp-solar-collector-efficiency, #js-erp-solar-collector-size, #js-erp-solar-rated-heat-output, #js-erp-solar-solar-tank-rating, #js-erp-solar-storage-volume'),
		collectorEfficiency: $('#js-erp-solar-collector-efficiency'),
		collectorSize: $('#js-erp-solar-collector-size'),
		ratedHeatOutput: $('#js-erp-solar-rated-heat-output'),
		solarTankRating: $('#js-erp-solar-solar-tank-rating'),
		storageTankVolume: $('#js-erp-solar-storage-volume'),
		solarRatingResult: $('#js-erp-solar-rating-hidden'),
	},
	hiddenFields: {
		boiler: $('#js-boiler-option-hidden'),
		boilerIsCombi: $('#js-boiler-option-is-combi-hidden'),
		controls: $('#js-controls-option-hidden'),
		renewable: $('#js-renewable-option-hidden'),
		hotWaterRating: $('#js-hot-water-rating-hidden'),
		all: $('#js-boiler-option-hidden, #js-controls-option-hidden, #js-renewable-option-hidden, #js-erp-solar-rating-hidden'),
		rating: $('#js-rating-hidden'),
	},
	template: {
		boilerControlsContent: $('#js-erp-boiler-controls-content-template'),
		boilerRating: $('#js-erp-boiler-rating-template'),
		controlsRating: $('#js-erp-controls-rating-template'),
		solarRating: $('#js-erp-solar-rating-template'),
		total: $('#js-erp-total-template')
	},
	templateTarget: {
		boilerContent: $('#js-erp-boiler-content'),
		controlsContent: $('#js-erp-controls-content'),
		boilerRating: $('#js-erp-boiler-rating'),
		controlsRating: $('#js-erp-controls-rating'),
		solarRating: $('#js-erp-solar-rating'),
		total: $('#js-erp-total'),
		contentDesktop: $('#js-erp-content-desktop'),
		ratingDesktop: $('#js-erp-rating-desktop'),
	},
	results: {
		rating: $('#js-erp-rating'),
		efficiency: $('#js-erp-total-efficiency'),
		efficiencyHotWater: $('#js-erp-total-efficiency-hot-water')
	},
	actions: {
		print: $('#js-erp-print-label-btn'),
		download: $('#js-erp-download-btn'),
	},
};

const vars = {
	baseURL: `${window.location.protocol}//${window.location.hostname}/erp/public`,
	key: 'GwQcQz8wLW9Io3VTFKqd8YSd3ns7mNs9',
	boilerActive: false,
	controlsActive: false,
	solarActive: false,
	emailFormActive: false,
	selectedBoiler: {
		name: '',
		rating: '',
		image: '',
		isCombi: false,
		hotWaterRating: '',
	},
	selectedControl: {
		name: '',
		rating: '',
		image: ''
	},
	selectedSolar: {
		name: '',
		rating: '',
		image: ''
	},
};

export default function init() {
	if (!$el.template.boilerControlsContent.length) return;

	resetTotalEfficiency();
	bindEvents();

	console.log('baseURL', vars.baseURL);
}

// User interactions go here
function bindEvents() {
	// Step 1
	boilerDropdownBindEvents();

	// Step 2
	controlsDropdownBindEvents();

	// Step 3
	solarToggleBindEvents();
	solarFieldsBindEvents();

	hiddenFieldsBindEvents();
	emailToggleBindEvents();

	// @TODO: Rewrite, doesn't currently work
	$('#calculateSolar').on('click', function (event) {
		console.log('calculateSolar click');
		event.preventDefault();
		solarFieldsBindEvents();

		erpGetCalculatedSolar();

	});

	// @TODO: Rewrite, doesn't currently work
	$('#js-erp-print-label-btn').on('click', function() {
		erpPrintLabel($(this));
	});

	// @TODO: Rewrite, doesn't currently work
	$el.emailForm.on('submit', function(e) {
		e.preventDefault();
		erpEmail();
	});
}

function boilerDropdownBindEvents() {
	if (!$el.boilerDropdown.length) return;

	$el.boilerDropdown.on('change', function() {
		erpSetSelected('boiler', $(this));
		erpUpdateAllRatings();
		erpToggleContent(vars.selectedBoiler, $el.boilerContent);
	});
}

function controlsDropdownBindEvents() {
	if (!$el.controlsDropdown.length) return;

	$el.controlsDropdown.on('change', function() {
		erpSetSelected('control', $(this));
		erpUpdateAllRatings();
		erpToggleContent(vars.selectedControl, $el.controlsContent);
	});
}

function solarToggleBindEvents() {
	if (!$el.solarToggle.length) return;

	$el.solarToggle.on('change', function() {
		const allSolarFieldsFilledOut = $el.solarFields.all.map(function() {
			return $(this).val().length;
		})
		.get()
		.reduce((a, b) => a + b, 0) > 0;

		if ($(this).is(':checked')) {
			vars.solarActive = true;

			showSolarForm();
			erpSetSelected('renewable', $('<div></div>').val('Solar'));
			if (allSolarFieldsFilledOut) erpGetCalculatedSolar();
		} else {
			vars.solarActive = false;

			hideSolarForm();
			erpSetSelected('renewable', $('<div></div>').data({
				rating: '',
			}));
			erpUpdateAllRatings();

			$el.solarFields.solarRatingResult.val(0);
			$el.solarFields.solarRatingResult.trigger('change');
		}
	});
}

function solarFieldsBindEvents() {
	if (!$el.solarForm.length) return;

	console.log('solarFieldsBindEvents');

	$el.solarForm.find('select, input').on('change', function () {
		console.log('$el.solarFields change');
		const solarRatedHeatOutput = $el.solarFields.ratedHeatOutput.val();
		const solarCollectorSize = $el.solarFields.collectorSize.val();
		const solarStorageTankVolume = $el.solarFields.storageTankVolume.val();
		const solarCollectorEfficiency = $el.solarFields.collectorEfficiency.val();
		const solarTankRating = $el.solarFields.solarTankRating.val();

		console.log('erpGetCalculatedSolar', !!erpGetCalculatedSolar);
		console.log('solarCollectorSize', !!solarCollectorSize);
		console.log('solarStorageTankVolume', !!solarStorageTankVolume);
		console.log('solarCollectorEfficiency', !!solarCollectorEfficiency);
		console.log('solarTankRating', !!solarTankRating);

		// Calculate solar when all fields are filled out
		if ((solarRatedHeatOutput !== '') &&
			(solarCollectorSize !== '') &&
			(solarStorageTankVolume !== '') &&
			(solarCollectorEfficiency !== '') &&
			(solarTankRating !== '')) {
			console.log('Should be true')
			erpGetCalculatedSolar();
		}
	});
}

function hiddenFieldsBindEvents() {
	if (!$el.hiddenFields.all.length) return;

	console.log('Gets to hiddenFieldsBindEvents');

	$el.hiddenFields.all.on('change', function () {

		console.log('Hidden fields change');
		const totalTemplate = Handlebars.compile($el.template.total.html());

		const selectedBoiler = (vars.selectedBoiler.rating !== '') ? vars.selectedBoiler.rating : 0;
		const selectedBoilerHotWater = (vars.selectedBoiler.hotWaterRating !== '') ? vars.selectedBoiler.hotWaterRating : 0;
		const selectedControl = (vars.selectedControl.rating !== '') ? vars.selectedControl.rating : 0;
		const selectedSolar = ((vars.selectedSolar.rating !== '') ? vars.selectedSolar.rating : 0) || 0;

		const totalEfficiency = ((vars.selectedBoiler.isCombi)
			? (vars.solarActive)
				? selectedBoiler
				: selectedBoiler + selectedControl
			: selectedBoiler + selectedControl + selectedSolar) || 0;

			console.log('totalEfficiency', totalEfficiency);

		const totalHotWaterEfficiency = ((vars.solarActive)
			? selectedBoilerHotWater + selectedControl + selectedSolar
			: selectedBoilerHotWater) || 0;

			console.log('totalHotWaterEfficiency', totalHotWaterEfficiency);

		let data = {
			totalEfficiency: String(Math.ceil(totalEfficiency * 10) / 10),
			totalEfficiencyGrade: caculateEfficiencyGrade(totalEfficiency) ? String(caculateEfficiencyGrade(totalEfficiency)) : '',
			totalEfficiencyColor: String(getEfficiencyGradeColor(caculateEfficiencyGrade(totalEfficiency))),
		};

		// Add hot water efficiency data if boiler is combination
		data = vars.selectedBoiler.isCombi
			? Object.assign({}, data, {
				totalHotWaterEfficiency: String(Math.ceil(totalHotWaterEfficiency * 10) / 10),
				totalHotWaterEfficiencyGrade: calculateHotWaterEfficiencyGrade(totalHotWaterEfficiency)
					? String(calculateHotWaterEfficiencyGrade(totalHotWaterEfficiency))
					: '',
				totalHotWaterEfficiencyColor: String(getEfficiencyGradeColor(calculateHotWaterEfficiencyGrade(totalHotWaterEfficiency))),
			})
			: data;

		$el.hiddenFields.rating.val(totalEfficiency);
		$el.hiddenFields.hotWaterRating.val(totalHotWaterEfficiency);

		// Render
		$el.templateTarget.total.empty();
		$el.templateTarget.total.append(totalTemplate(data));
	});

	// Enable buttons 'Print label', 'Download', 'Email' when boiler or controls selected
	$('#js-boiler-option-hidden, #js-controls-option-hidden').on('change', function() {
		const bothBoilerAndControlsNotSelected = $('#js-boiler-option-hidden, #js-controls-option-hidden')
			.map(function() {
				return $(this).val().length;
			})
			.get()
			.reduce((a, b) => a + b, 0) === 0;

		if (bothBoilerAndControlsNotSelected) {
			$el.actions.download.attr('disabled', true);
			$el.actions.print.attr('disabled', true);
			$el.emailToggle.attr('disabled', true);
		}

		if ($(this).val().length !== 0) {
			$el.actions.download.attr('disabled', false);
			$el.actions.print.attr('disabled', false);
			$el.emailToggle.attr('disabled', false);
		}
	});
}

function emailToggleBindEvents() {
	if (!$el.emailToggle.length) return;

	$el.emailToggle.on('click', function(e) {
		e.preventDefault();

		if (vars.emailFormActive) {
			$el.emailForm.slideUp();
		} else {
			$el.emailForm.slideDown();
		}

		vars.emailFormActive = !vars.emailFormActive;
	});
}

function resetTotalEfficiency() {
	const totalTemplate = Handlebars.compile($el.template.total.html());

	$el.templateTarget.total.append(totalTemplate({
		totalEfficiency: 0,
		totalEfficiencyGrade: '',
		totalEfficiencyColor: 'grey',
	}));
}

function getEfficiencyGradeColor(grade) {
	const gradeIndex = ['G', 'F', 'E', 'D', 'C', 'B', 'A', 'A+', 'A++', 'A+++'].indexOf(grade);

	// No grade: grey
	// G – A: yellow
	// A – end: green
	return gradeIndex !== -1
		?	gradeIndex > 6
			? 'green'
			: 'yellow'
		: 'grey';
}

function caculateEfficiencyGrade(rating) {
	if (rating === 0) return null;

	let efficiencyGrade;

	if (rating >= 150) {
		efficiencyGrade = 'A+++';
	} else if (rating >= 125) {
		efficiencyGrade = 'A++';
	} else if (rating >= 98) {
		efficiencyGrade = 'A+';
	} else if (rating >= 90) {
		efficiencyGrade = 'A';
	} else if (rating >= 82) {
		efficiencyGrade = 'B';
	} else if (rating >= 75) {
		efficiencyGrade = 'C';
	} else if (rating >= 36) {
		efficiencyGrade = 'D';
	} else if (rating >= 34) {
		efficiencyGrade = 'E';
	} else if (rating >= 30) {
		efficiencyGrade = 'F';
	} else if (rating < 30) {
		efficiencyGrade = 'G';
	}

	return efficiencyGrade;
}

function calculateHotWaterEfficiencyGrade(rating) {
	if (rating === 0) return null;

	let efficiencyGrade;

	if (rating >= 163) {
		efficiencyGrade = 'A+++';
	} else if (rating >= 130) {
		efficiencyGrade = 'A++';
	} else if (rating >= 100) {
		efficiencyGrade = 'A+';
	} else if (rating >= 65) {
		efficiencyGrade = 'A';
	} else if (rating >= 39) {
		efficiencyGrade = 'B';
	} else if (rating >= 36) {
		efficiencyGrade = 'C';
	} else if (rating >= 33) {
		efficiencyGrade = 'D';
	} else if (rating >= 30) {
		efficiencyGrade = 'E';
	} else if (rating >= 27) {
		efficiencyGrade = 'F';
	} else if (rating < 27) {
		efficiencyGrade = 'G';
	}

	return efficiencyGrade;
}

// type: boiler, control, renewable.
// option: jQuery object for the selected option.
function erpSetSelected(type, $target) {
	const $option = $target.is('select')
		? $target.find(`option[value="${$target.val()}"]`)
		: $target;

	const selectedItem = {
		name: $option.val() || '',
		rating: $option.data('rating') ? Number($option.data('rating')) : '',
		image: $option.data('image') || ''
	};

	switch (type) {
	case 'boiler': {
		vars.boilerActive = !!$option.val();
		selectedItem.isCombi = $option.data('isCombi');
		selectedItem.hotWaterRating = Number($option.data('hotWaterRating'));
		vars.selectedBoiler = selectedItem;

		// Update hidden inputs
		$el.hiddenFields.boilerIsCombi.val(selectedItem.isCombi);
		$el.hiddenFields.boiler.val(selectedItem.name);
		$el.hiddenFields.boiler.trigger('change');
		break;
	}
	case 'control': {
		vars.controlsActive = !!$option.val();
		selectedItem.rating = (typeof $option.data('rating') !== 'undefined')
			? $option.data('rating') === 0
				? 0
				: $option.data('rating')
			: vars.controlsActive
				? 0
				: '';
		vars.selectedControl = selectedItem;

		// Update hidden inputs
		$el.hiddenFields.controls.val(selectedItem.name);
		$el.hiddenFields.controls.trigger('change');
		break;
	}
	case 'renewable': {
		selectedItem.rating = $option.data('rating') === '' ? '' : $option.data('rating');
		vars.selectedSolar = selectedItem;

		// Update hidden inputs
		$el.hiddenFields.renewable.val(selectedItem.name);
		$el.hiddenFields.renewable.trigger('change');
		break;
	}
	default:
		break;
	}
}

function erpToggleContent(data, $target) {
	if (!data.name && !data.image && !data.rating) {
		// CLOSE

		$target
			.fadeOut()
			.empty();

		if (!vars.boilerActive && !vars.controlsActive && !vars.solarActive) {
			$el.templateTarget.contentDesktop.fadeOut();
		}

	} else {
		// OPEN

		const contentTemplate = Handlebars.compile($el.template.boilerControlsContent.html());

		$target
			.empty()
			.append(contentTemplate(data))
			.fadeIn();

		$el.templateTarget.contentDesktop
			.fadeIn()
			.css({ display: 'flex' });
	}
}

function erpUpdateAllRatings() {
	['boilerRating', 'controlsRating', 'solarRating'].map(rating => erpUpdateRating(rating));

	// Hide container
	if (!vars.boilerActive && !vars.controlsActive && !vars.solarActive) {
		$el.templateTarget.ratingDesktop.fadeOut();
	}
}

function erpUpdateRating(type) {
	const data = {
		boilerRating: String(vars.selectedBoiler.rating),
		controlsRating: String(vars.selectedControl.rating),
		solarRating: String(vars.selectedSolar.rating),
	};

	if (!data[type]) {
		$el.templateTarget[type]
			.fadeOut()
			.empty();
	} else {
		const template = Handlebars.compile($el.template[type].html());

		$el.templateTarget[type]
			.empty()
			.append(template(data))
			.fadeIn();

		$el.templateTarget.ratingDesktop
			.fadeIn()
			.css({ display: 'flex' });
	}
}

function resetSolarRating() {
	$el.solarFields.solarRatingResult.val(0);

	erpSetSelected('renewable', $('<div></div>').data({
		rating: 0,
	}).val('Solar'));

	erpUpdateAllRatings();

	$el.solarFields.solarRatingResult.trigger('change');
}

// @TODO: Rewrite, doesn't currently work
function erpGetCalculatedSolar() {
	$.ajax({
		type: 'POST',
		url: `${vars.baseURL}/solar.php`,
		dataType: 'json',
		data: {
			key: vars.key,
			'solar-rated-heat-output': $el.solarFields.ratedHeatOutput.val(),
			'solar-collector-size': $el.solarFields.collectorSize.val(),
			'solar-storage-tank-volume': $el.solarFields.storageTankVolume.val(),
			'solar-collector-efficiency': $el.solarFields.collectorEfficiency.val(),
			'solar-tank-rating': $el.solarFields.solarTankRating.val(),
		}
	}).done((response) => {
		if (response.status === 'success') {

			console.log('Success');

			$el.solarFields.solarRatingResult.val(response.value);
			erpSetSelected('renewable', $('<div></div>').data({
				rating: Number(Math.ceil(response.value * 10) / 10),
			}));
			erpUpdateAllRatings();

			$el.solarFields.solarRatingResult.trigger('change');

		} else {
			resetSolarRating();
			console.log('Done but not success');
		}

	}).fail(() => {
		resetSolarRating();
		console.log('Fail');
	});
}

function erpEmail() {
	const name = $el.emailNameInput.val();
	const email = $el.emailAddressInput.val();
	const rating = $el.hiddenFields.rating.val();
	const hotWaterRating = $el.hiddenFields.hotWaterRating.val();

	// Add spinner
	$el.emailSubmitBtn.addClass('is-loading').attr('disabled', true);
	$el.emailStatus.text('Email sending...');

	$.ajax({
		type: 'POST',
		url: `${vars.baseURL}/email.php`,
		dataType: 'json',
		data: {
			key: vars.key,
			delivery: 'email',
			rating,
			boiler: vars.selectedBoiler.name,
			control: vars.selectedControl.name,
			renewable: vars.selectedSolar.name || false,
			isCombi: vars.selectedBoiler.isCombi || false,
			hotWaterRating,
			name,
			email
		}
	}).done(function (response) {
		$el.emailSubmitBtn.removeClass('is-loading').attr('disabled', false);
		$el.emailStatus.text(response.message);
		setTimeout(() => $el.emailStatus.text(''), 2000);
	}).fail(function (response) {
		$el.emailSubmitBtn.removeClass('is-loading').attr('disabled', false);
		$el.emailStatus.text(response.message);
		setTimeout(() => $el.emailStatus.text(''), 2000);
	});
}

function erpPrintLabel($printBtn) {
	const rating = $el.hiddenFields.rating.val();
	const hotWaterRating = $el.hiddenFields.hotWaterRating.val();

	$printBtn.addClass('is-loading').attr('disabled', true);

	$.ajax({
		type: 'POST',
		url: `${vars.baseURL}/print.php`,
		dataType: 'json',
		data: {
			key: vars.key,
			delivery: 'url',
			rating,
			boiler: vars.selectedBoiler.name,
			control: vars.selectedControl.name,
			renewable: vars.selectedSolar.name,
			isCombi: vars.selectedBoiler.isCombi,
			hotWaterRating
		}
	}).done((response) => {

		if (response.status === 'success') {

			console.log('Print success');

			$('#print-label-frame').contents().find('#print-label-image').attr('src', `data:image/png;base64,${response.value}`);

			// Wait for the image to load before triggering the print.
			$('#print-label-frame').contents().find('#print-label-image').one('load', function() {

				$('#print-label-frame').css({
					height: 10,
					visibility: 'visible',
					width: 10,
				});

				$('#print-label-frame').get(0).contentWindow.focus();
				$('#print-label-frame').get(0).contentWindow.print();

				$('#print-label-frame').css({
					height: 0,
					visibility: 'hidden',
					width: 0,
				});

				$printBtn.removeClass('is-loading').attr('disabled', false);
			});

		} else {
			$printBtn.removeClass('is-loading').attr('disabled', false);
		}

	}).fail((response) => {
		console.log('Print fail');
		$printBtn.removeClass('is-loading').attr('disabled', false);
	});
}

function showSolarForm() {
	if (!$el.solarForm.length) return;
	$el.solarForm
		.fadeIn()
		.css({ display: 'flex' });
	$el.templateTarget.contentDesktop.fadeIn().css({ display: 'flex' });
}

function hideSolarForm() {
	if (!$el.solarForm.length) return;
	$el.solarForm
		.css({ display: 'block' })
		.fadeOut();

	$el.templateTarget.solarRating
		.empty()
		.fadeOut();

	if (!vars.boilerActive && !vars.controlsActive && !vars.solarActive) {
		$el.templateTarget.contentDesktop
			.css({ display: 'block' })
			.fadeOut();
	}

	if (!vars.boilerActive && !vars.controlsActive && !vars.solarActive) {
		$el.templateTarget.ratingDesktop.fadeOut();
	}
}